<div class="container">
<!--  <div class="arrow left-arrow" (click)="goToPreviousPage()">-->
<!--    <span>&#8249;</span>-->
<!--  </div>-->

  <div class="content">
    <div *ngIf="currentPage === 1">
      <h1>Digitalna Dnevna parkirališna karta</h1>
      <p>
        Dnevnu parkirališnu kartu (DPK) izdaje organizator parkiranja, a u skladu s
        <a href="#" class="highlighted-link">Odlukom o organizaciji i načinu naplate parkiranja</a>,
        ukoliko na parkirališnom mjestu pod naplatom zatekne vozilo bez valjane parkirališne karte.
        Dnevnu parkirališnu kartu korisnici parkiranja mogu kupiti i putem dostupnih prodajnih kanala.
        Dnevna parkirališna karta izdaje se u vremenskom trajanju od 24 sata.
      </p>
    </div>
<!--    <div *ngIf="currentPage === 2">-->
<!--      <h1>Digitalna Dnevna parkirališna karta</h1>-->
<!--      <p>Ovo je sadržaj za stranicu 2</p>-->
<!--    </div>-->
<!--    <div *ngIf="currentPage === 3">-->
<!--      <h1>Digitalna Dnevna parkirališna karta</h1>-->
<!--      <p>Ovo je sadržaj za stranicu 3</p>-->
<!--    </div>-->

    <div class="button-group">
      <button class="check-button" (click)="goToCardDetails()">Provjeri</button>
<!--      <button class="more-info-button">Saznaj više</button>-->
    </div>

      <span class="dot" [class.active]="currentPage === 1" (click)="goToPage(1)"></span>
<!--      <span class="dot" [class.active]="currentPage === 2" (click)="goToPage(2)"></span>-->
<!--      <span class="dot" [class.active]="currentPage === 3" (click)="goToPage(3)"></span>-->
    </div>

<!--  <div class="arrow right-arrow" (click)="goToNextPage()">-->
<!--    <span>&#8250;</span>-->
<!--  </div>-->
</div>
